import {
  TableBody as TableBodyUI,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Table as TableUI,
} from '../ui/table'
import type { ReactNode } from 'react'

export function Table({ children }: { children: ReactNode }) {
  return <TableUI className="w-full text-sm">{children}</TableUI>
}
export function THead({ children }: { children: ReactNode }) {
  return (
    <TableHeader className="bg-neutral-100 text-left">{children}</TableHeader>
  )
}
export function TBody({ children }: { children: ReactNode }) {
  return <TableBodyUI className="divide-y">{children}</TableBodyUI>
}
export function TR({
  children,
  onClick,
}: {
  children: ReactNode
  onClick?: () => void
}) {
  return (
    <TableRow onClick={onClick} className="hover:bg-neutral-50">
      {children}
    </TableRow>
  )
}
export function TH({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <TableHead className={'px-3 py-2 font-medium ' + (className ?? '')}>
      {children}
    </TableHead>
  )
}
export function TD({
  children,
  className,
  colSpan,
}: {
  children: ReactNode
  className?: string
  colSpan?: number
}) {
  return (
    <TableCell className={'px-3 py-2 ' + (className ?? '')} colSpan={colSpan}>
      {children}
    </TableCell>
  )
}
